<jbm-modal [id]="'receipt'" [className]="'content'" (onClose)="close()"></jbm-modal>
<ng-template #modalReceipt let-modal>

<form [formGroup]="form" (ngSubmit)="save()" class="manual-receipt-entry">
  <div class="jbm-modal-header">
    <div class="title">
      {{'menu.production'|translate}}{{'production.receipt'|translate|lowercase}} {{'entity.create'|translate|lowercase}}
    </div>
    <div class="toolbar float-end">
       <div class="action-buttons">
         <jbm-save-button subject="{{'menu.production'|translate}} {{'production.receipt'|translate}}" [small]="false" (click)="save()"></jbm-save-button>
         <jbm-cancel-button context="secondary" [small]="false" (click)="close()"></jbm-cancel-button>
       </div>
       <div class="toolbar-spacer-1"></div>
       <div class="btn-toolbar">
          <jbm-help-button [class]="'light'" [helpTopicID]="0"></jbm-help-button>
       </div>
    </div>
  </div>
  <div class="jbm-modal-body">
      <project-selector [labelCaption]="'entity.project'|translate" labelClass="lg" class="lg"
          [id]="'projects_id'" [template]="projectselect" [project_id]="project ? project.id : 0"
          (projectSelected)="selectProject($event)">
          <ng-template #projectselect let-project="project">
            <div *ngIf="project">
                <jbm-link-button [caption]="project.name" (onClick)="showProject()">{{'ui.details'|translate}}</jbm-link-button>
                <div class="jbm-properties-list mt-2">
                  <div *ngIf="!order || !order.plants_id" class="item">
                      <label class="label w-6rem">{{'company.plant'|translate}}:</label>
                      <label class="value">{{getPlantName(project.plants_id)}}</label>
                  </div>
                  <div class="item">
                      <label class="label w-6rem">{{'project.state'|translate}}:</label>
                      <label class="value">
                        <span class="badge badge-pill" style="background-color: {{project.projectState.color}};color: {{project.projectState.text_color}}">
                            {{project.projectState.description}}
                        </span>
                      </label>
                  </div>
                  <div *ngIf="customer && customer.name" class="item">
                      <label class="label w-6rem">{{'entity.customer'|translate}}:</label>
                      <label class="value">
                        <jbm-link-button [caption]="customer.name" class="pt-1" (onClick)="showCustomer()">{{'ui.details'|translate}}</jbm-link-button>
                      </label>
                  </div>
                </div>
            </div>
          </ng-template>
      </project-selector>
      <order-selector [labelCaption]="'project.order'|translate" labelClass="lg" class="lg" [disabled]="!project || !project.id"
          [id]="'orders_id_selector'" [template]="orderselect" [order_id]="order ? order.id : 0"
          [projects_id]="project ? project.id : 0" (orderSelected)="selectOrder($event)">
          <ng-template #orderselect let-order="order">
            <div *ngIf="order">
                <jbm-link-button [caption]="order.description" (onClick)="showOrder()">{{'ui.details'|translate}}</jbm-link-button>
                <div class="jbm-properties-list mt-2">
                  <div *ngIf="order.plants_id" class="item">
                      <label class="label w-6rem">{{'company.plant'|translate}}:</label>
                      <label class="value">{{getPlantName(order.plants_id)}}</label>
                  </div>
                  <div class="item">
                      <label class="label w-6rem">{{'order.amount'|translate}}:</label>
                      <label class="value">{{order.amount|float:2}} {{'quantity.m3'|translate}}</label>
                  </div>
                  <div class="item">
                      <label class="label w-6rem">{{'order.remaining'|translate}}:</label>
                      <label class="value">{{remainingAmount|float:2}} {{'quantity.m3'|translate}}</label>
                  </div>
                  <div *ngIf="recipe" class="item">
                      <label class="label w-6rem">{{'entity.recipe'|translate}}:</label>
                      <label class="value">
                        <jbm-link-button [caption]="recipe.description" class="pt-1" (onClick)="showRecipe()">{{'ui.details'|translate}}</jbm-link-button>
                      </label>
                  </div>
                </div>
            </div>
          </ng-template>
      </order-selector>

      <div class="form-section-separator">{{'menu.production'|translate}} {{'entity.data'|translate|lowercase}}</div>

      <jbm-select [formControl]="formControls.plants_id" [options]="plantOptions" [disabled]="!editable" [submitted]="isSubmitted" class="lg"
        [id]="'plants_id'" labelCaption="{{'company.plant'|translate}}" labelClass="lg" (onChange)="selectPlant($event)">
      </jbm-select>
      <jbm-integer-input-group [formControl]="formControls.receipts_id" [submitted]="isSubmitted"
          [id]="'receipt_id'" required="true" class="xxxxs mb-3" [disabled]="!editable"
          labelCaption="{{'production.receipt'|translate}} {{'ui.id'|translate}}" labelClass="lg"
          [negativeAllowed]="false" (onBlur)="checkUnique()">
          <jbm-input-error [formControl]="formControls.receipts_id" [submitted]="isSubmitted">
            <span *ngIf="form.controls['receipts_id'].hasError('required')">
                {{'entity.requiredfield'|translate}}
            </span>
            <span *ngIf="form.controls['receipts_id'].hasError('not_unique')">
                {{'entity.number-not-unique'|translate}}
            </span>
          </jbm-input-error>
      </jbm-integer-input-group>

      <jbm-date-input [formControl]="formControls.execute_date" [submitted]="isSubmitted" [id]="'execute_date'"
          labelCaption="{{'datetime.date'|translate}}" labelClass="lg" required="true" [disabled]="!editable">
          <jbm-input-error [formControl]="formControls.execute_date" [submitted]="isSubmitted">
            {{'entity.dateformat'|translate}}
          </jbm-input-error>
      </jbm-date-input>
      <jbm-time-input [formControl]="formControls.loading_time" [submitted]="isSubmitted" [id]="'loading_time'"
          labelCaption="{{'datetime.start'|translate}}" labelClass="lg" required="true" [disabled]="!editable">
          <jbm-input-error [formControl]="formControls.loading_time" [submitted]="isSubmitted">
            <span *ngIf="form.controls['receipts_id'].hasError('required')">
              {{'entity.timeformat'|translate}}
            </span>
            <span *ngIf="form.controls['loading_time'].hasError('to-late')">
              {{'entity.end-time-before-from-time'|translate}}
            </span>
          </jbm-input-error>
      </jbm-time-input>
      <jbm-time-input [formControl]="formControls.leave_plant_time" [submitted]="isSubmitted" class="mb-3"
          [id]="'leave_plant_time'" labelCaption="{{'datetime.stop'|translate}}" labelClass="lg" required="true" [disabled]="!editable">
          <jbm-input-error [formControl]="formControls.leave_plant_time" [submitted]="isSubmitted">
            {{'entity.timeformat'|translate}}
          </jbm-input-error>
      </jbm-time-input>

      <truck-selector #truckSelector [labelCaption]="'production.truck'|translate" labelClass="lg" class="lg"
          [id]="'trucks_id'" [required]="true" [disabled]="!editable" [template]="truckselect" [truck_id]="truck.id" [plant_id]="plant_id"
          (truckSelected)="selectTruck($event)">
          <ng-template #truckselect let-truck="truck">
            <div class="jbm-properties-list">
              <div class="item">
                  <label class="label w-6rem">{{'ui.number'|translate}}:</label>
                  <label class="value">{{truck.number}}</label>
              </div>
              <div class="item">
                  <label class="label w-6rem">{{'truck.numberplate'|translate}}:</label>
                  <label class="value">{{truck.numberplate}}</label>
              </div>
              <div class="item">
                  <label class="label w-6rem">{{'production.capacity'|translate}}:</label>
                  <label class="value">{{truck.capacity}} {{'quantity.m3'|translate}}</label>
              </div>
            </div>
          </ng-template>
      </truck-selector>
      <driver-selector #driverSelector [labelCaption]="'production.driver'|translate" labelClass="lg" class="lg mb-3"
          [id]="'drivers_id'" [required]="true" [disabled]="!editable" [template]="driverselect" [driver_id]="driver.id"
          (driverSelected)="selectDriver($event)">
          <ng-template #driverselect let-driver="driver">
            <span *ngIf="driver">{{driver.name}}</span>
          </ng-template>
      </driver-selector>

      <jbm-float-input-group [formControl]="formControls.receipt_amount" [submitted]="isSubmitted"
          [id]="'receipt_amount'" required="true" [disabled]="!editable" [inputClass]="'xxs'" append="{{'quantity.m3'|translate}}"
          labelCaption="{{'production.receipt'|translate}} {{'order.amount'|translate|lowercase}}" labelClass="lg"
          decimals="2" [decimalsOptional]="true" [negativeAllowed]="false">
          <jbm-input-error [formControl]="formControls.receipt_amount" [submitted]="isSubmitted">
            {{'entity.concrete-amount-format'|translate}}
          </jbm-input-error>
      </jbm-float-input-group>
      <jbm-float-input-group [formControl]="formControls.amount" [submitted]="isSubmitted" [id]="'amount'"
          required="true" [disabled]="!editable" [inputClass]="'xxs'" append="{{'quantity.m3'|translate}}"
          labelCaption="{{'menu.production'|translate}} {{'order.amount'|translate|lowercase}}" labelClass="lg"
          decimals="2" [decimalsOptional]="true" [negativeAllowed]="false" (onBlur)="copyAmountToReceiptAmount()">
          <jbm-input-error [formControl]="formControls.amount" [submitted]="isSubmitted">
            {{'entity.concrete-amount-format'|translate}}
          </jbm-input-error>
      </jbm-float-input-group>

      <jbm-textarea [formControl]="formControls.comment" [submitted]="isSubmitted" [id]="'comment'" class="lg comments mt-3"
        labelCaption="{{'entity.comments'|translate}}" labelClass="lg" rows="4" [disabled]="!editable">
          <jbm-input-error [formControl]="formControls.comment" [submitted]="isSubmitted">
            {{'entity.requiredfield'|translate}}
          </jbm-input-error>
      </jbm-textarea>
   </div>
</form>

<jbm-modal [id]="'customerDetails'" [className]="'customer-details'"></jbm-modal>
<ng-template #modalCustomerDetails let-modal>
    <customer-details [customer]="customer" [inModal]="true" (onClose)="closeCustomer()"></customer-details>
</ng-template>

<jbm-modal [id]="'projectDetails'" [className]="'project-details'"></jbm-modal>
<ng-template #modalProjectDetails let-modal>
    <project-details [project_id]="project.id" (onClose)="closeProject()"></project-details>
</ng-template>

<jbm-modal [id]="'orderDetails'" [className]="'order-details'"></jbm-modal>
<ng-template #modalOrderDetails let-modal>
   <order-details [order_id]="order.id" (onClose)="closeOrder()"></order-details>
</ng-template>

<jbm-modal [id]="'recipeDetails'" [className]="'recipe-details'"></jbm-modal>
<ng-template #modalRecipeDetails let-modal>
   <recipe-details [plant_id]="plant_id" [order_id]="order.id" [recipe_id]="recipe.id" (onClose)="closeRecipe()"></recipe-details>
</ng-template>

<jbm-toasts></jbm-toasts>
